var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"animated"}},[_c('b-card',[_c('b-card-header',[_c('i',{staticClass:"icon-menu mr-1"}),_vm._v(" Data Table Release Point ")]),_c('b-card-body',[_c('Release-point')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }